import c from 'classnames';

import { Typography } from 'components';

import {
  parseTags,
  TINY_PLUS_TAG_LABEL,
  TINY_PLUS_TAG_VARIANTS,
} from '../VideoResources.helpers';
import styles from './Webinars.module.css';

// Renders the comma-separated tag string as pills, giving any Tiny+ tag the
// gold treatment. Legacy DB variants (e.g. "Tiny+ Member Exclusive") are
// normalized to the canonical "Tiny+ Exclusive" label.
export const ResourceTags = ({ tags }: { tags?: string }) => {
  const parsed = parseTags(tags);
  if (!parsed.length) return null;

  return (
    <div className={styles.tags}>
      {parsed.map(tag => {
        const isTinyPlus = TINY_PLUS_TAG_VARIANTS.has(tag);
        return (
          <span
            key={tag}
            className={c(styles.tag, isTinyPlus && styles.tagTinyPlus)}
          >
            <Typography variant='label'>
              {isTinyPlus ? TINY_PLUS_TAG_LABEL : tag}
            </Typography>
          </span>
        );
      })}
    </div>
  );
};
